import { useTranslation } from "react-i18next";

export interface Props {
  subTotal: number;
  vat: number;
  totalAmount: number;
  currency: string;
}

export function PriceTotal({ subTotal, vat, totalAmount, currency }: Props) {
  const { t } = useTranslation();
  return (
    <div className={"w-full text-sm space-y-2 my-5 pr-4"}>
      <div className={"grid grid-cols-9 border-b pb-3"}>
        <div className={"col-span-7"}></div>
        <p className={"capitalize justify-self-end col-span-1"}>
          {t("orderListDetails.subtotal")}
        </p>
        <p className={"justify-self-end col-span-1"}>
          {currency} {subTotal.toFixed(2)}
        </p>
      </div>
      <div className={"grid grid-cols-9 border-b pb-3"}>
        <div className={"col-span-7"}></div>
        <p className={"uppercase justify-self-end col-span-1"}>
          {t("orderListDetails.vat")}
        </p>
        <p className={"justify-self-end col-span-1"}>
          {currency} {vat.toFixed(2)}
        </p>
      </div>
      <div className={"grid grid-cols-9 font-bold"}>
        <div className={"col-span-7"}></div>
        <p className={"capitalize justify-self-end col-span-1"}>
          {t("orderListDetails.totalAmount")}
        </p>
        <p className={"justify-self-end col-span-1"}>
          {currency} {totalAmount.toFixed(2)}
        </p>
      </div>
    </div>
  );
}
